export default "__VITE_ASSET__CpGjxpLQ__"